module.exports = __webpack_public_path__ + "static/media/office-4.ceab0967.jpg";